import { combineReducers } from 'redux';
import screenerReducer from './reducers/screen-reducer';
import filterReducer from './reducers/filter-reducer';
import rowDocsAndDisclosuresReducer from './reducers/row-documents-disclosures-reducer';
import chartReducer from './reducers/chart-reducer';

const rootReducer = combineReducers({
  filterReducer,
  resultData: screenerReducer,
  rowDocsAndDisclosuresReducer,
  chartReducer
});

export default rootReducer;
